
    import { Component, Vue } from 'vue-property-decorator';
    import { mapState } from 'vuex';
    import RechnungenDatatable from '@/components/Impfverwaltung/Rechnung/RechnungenDatatable.vue';

    @Component({
        components: {
            RechnungenDatatable,
        },
        computed: {
            ...mapState('patient', ['patientData']),
        },
    })
    export default class RechnungenTabitem extends Vue {
    }
